import { TableNew, TableRecord } from '@dynamika-shared/ui/TableNew/TableNew';
import { TrashIcon } from '@dynamika-shared/ui/icons';
import { ReactNode } from 'react';
import { Tooltip } from 'antd';
import { MAX_LENGTH_NAME } from 'src/pages/ClinicalTrial/ClinicalTrialVisits/CohortList';
import { FormsControlSchemaType } from 'src/pages/ClinicalTrial/uiControlSchemaByStatus/ControlTypes';
import { VisitConfig } from '@dynamika-shared/types/visits';
import { twMerge } from '@utils/twMerge';
import { Questionnaire } from '@dynamika-shared/types/questionnaire';

export type QuestionnaireDataSourceItem = {
  key: string;
  name: ReactNode;
  action: ReactNode;
  disabled?: boolean;
};

const expandedColumns = (disabled?: boolean, isPM?: boolean) => [
  {
    title: 'Name',
    dataIndex: 'name',
    className: 'w-[20%] min-w-[20%] max-w-[20%]',
  },
  { title: 'Data Type', dataIndex: 'dataType' },
  { title: 'Alias', dataIndex: 'alias' },
  {
    title: (
      <div className={twMerge('text-right', disabled && 'text-platinum')}>
        {!isPM && (<span>Action</span>)}
      </div>
    ),
    dataIndex: 'action',
    key: 'action',
  },
];

export const transformExpandedVisit =
  (
    uiControlSchema: FormsControlSchemaType,
    deleteFormAction: (questionnaireId: string) => void,
    isPM: boolean
  ) =>
  (visit: VisitConfig & { questionnaires: Questionnaire[] }) => {
    const memoizedVisitsDataSource: QuestionnaireDataSourceItem[] = [
      ...visit.questionnaires,
    ].map((form, i) => ({
      key: `${form.id}-${i}`,
      name: (
        <Tooltip
          color='white'
          className='flex items-center gap-1'
          title={
            form.clinicalTrialQuestionnaireId.length > MAX_LENGTH_NAME && (
              <span className={'text-black'}>{form.name}</span>
            )
          }
        >
          <div className='max-w-full truncate'>{form.name}</div>
        </Tooltip>
      ),
      dataType: <div>{form.dataType}</div>,
      alias: <div>{form.alias}</div>,
      action: (
        <div className='flex justify-end gap-1'>
          {!uiControlSchema.deleteForm.hidden && !isPM && (
            <TrashIcon
              className='cursor-pointer hover:text-dodgerBlue'
              width={24}
              height={24}
              onClick={() => deleteFormAction(form.id)}
              data-tesitid={`deleteSpecForm-${form.id}`}
            />
          )}
        </div>
      ),
    }));
    return (
      <TableNew<TableRecord>
        columns={expandedColumns(
          uiControlSchema.deleteForm.hidden || uiControlSchema.editForm.hidden, isPM
        )}
        dataSource={memoizedVisitsDataSource}
        pagination={false}
        tableClassName='nested-table !bg-white'
      />
    );
  };
